import { RatingStars } from '../RatingStars';

export const ServiceTestimonials = () => (
<>
<h2 className="text-3xl font-bold text-red-500 mb-6 mt-12">
              Témoignages Retour Affectif en Guadeloupe
            </h2>
            <div className="space-y-6 mb-8">
              <div className="bg-gray-900/60 p-6 rounded-xl border border-yellow-400/30">
                <div className="flex mb-3">
                  <RatingStars rating={5} />
                </div>
                <p className="text-gray-300 italic mb-4">
                  "Après 11 mois de séparation, le rituel de retour affectif de Maître Diamma a ramené mon ex en seulement 6 jours. 
                  C'est incroyable ! Il est revenu me supplier de reprendre. Ce marabout africain est vraiment puissant."
                </p>
                <p className="text-white font-semibold">Sophie M. - Pointe-à-Pitre</p>
              </div>
              <div className="bg-gray-900/60 p-6 rounded-xl border border-yellow-400/30">
                <div className="flex mb-3">
                  <RatingStars rating={5} />
                </div>
                <p className="text-gray-300 italic mb-4">
                  "Mon ex était marié avec quelqu'un d'autre. Je pensais que c'était impossible. Le sorcier vaudou Maître Diamma 
                  a fait des miracles. En 3 semaines, mon ex a quitté sa femme et est revenu avec moi. Merci infiniment !"
                </p>
                <p className="text-white font-semibold">Marc T. - Les Abymes</p>
              </div>
            </div>
</>
);
